import { defineStore } from 'pinia';
import { ref, computed, watch } from 'vue';
import { apiService } from '../services/api';

export const useCartStore = defineStore('cart', () => {
  const savedItems = localStorage.getItem('cart_items');
  const items = ref(savedItems ? JSON.parse(savedItems) : []);
  const isOpen = ref(false);
  const shippingCost = ref(15); // Default fallback
  const shippingName = ref('Livraison Standard');

  // Computed
  const itemCount = computed(() =>
    items.value.reduce((sum, item) => sum + item.quantity, 0)
  );

  const total = computed(() =>
    items.value.reduce((sum, item) => sum + item.price * item.quantity, 0)
  );

  const totalWeight = computed(() =>
    items.value.reduce((sum, item) => sum + (parseInt(item.weight) || 0) * item.quantity, 0)
  );

  // Actions
  function addItem(product) {
    const existing = items.value.find(i => i.id === product.id);
    if (existing) {
      existing.quantity++;
    } else {
      items.value.push({ ...product, quantity: 1 });
    }
    isOpen.value = true;
  }

  function removeItem(productId) {
    items.value = items.value.filter(i => i.id !== productId);
  }

  function updateQty(productId, qty) {
    const item = items.value.find(i => i.id === productId);
    if (!item) return;
    if (qty <= 0) {
      removeItem(productId);
    } else {
      item.quantity = qty;
    }
  }

  function clearCart() {
    items.value = [];
  }

  function openCart() { isOpen.value = true; }
  function closeCart() { isOpen.value = false; }

  async function updateShippingCost() {
    if (items.value.length === 0) {
      shippingCost.value = 0;
      return;
    }
    try {
      const res = await apiService.getShippingCost(totalWeight.value, total.value);
      shippingCost.value = res.data.shipping_cost;
      shippingName.value = res.data.shipping_name;
    } catch (err) {
      console.error('Failed to fetch shipping cost', err);
    }
  }

  // Watchers
  watch(items, (newItems) => {
    localStorage.setItem('cart_items', JSON.stringify(newItems));
  }, { deep: true });

  // Watch for changes in total weight to update shipping cost
  watch(totalWeight, () => {
    updateShippingCost();
  }, { immediate: true });

  return { items, isOpen, itemCount, total, totalWeight, shippingCost, shippingName, addItem, removeItem, updateQty, clearCart, openCart, closeCart, updateShippingCost };
});
